import { render, staticRenderFns } from "./siteBatch.vue?vue&type=template&id=275528ca&scoped=true"
import script from "./siteBatch.vue?vue&type=script&lang=js"
export * from "./siteBatch.vue?vue&type=script&lang=js"
import style0 from "./siteBatch.vue?vue&type=style&index=0&id=275528ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275528ca",
  null
  
)

export default component.exports